import React from 'react'
import ProductTile from '../product-tile'

const FullDashboard = ({ products, ...props }) => products.map(product => (
  <ProductTile product={product} key={product.uuid} {...props} />
))

export default FullDashboard
